import Swiper from 'swiper';
import { Navigation, Pagination, Scrollbar, Autoplay, EffectFade, Thumbs, FreeMode, Mousewheel } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/autoplay';
import 'swiper/css/effect-fade';
import 'swiper/css/thumbs';

const featuresSliderLeft = new Swiper('.features-slider-left', {
    modules: [Navigation, Pagination, Scrollbar, Autoplay, EffectFade, Thumbs, FreeMode, Mousewheel],
    direction: "vertical",
    slidesPerView: "auto",
    spaceBetween: 28,
    loop: true,
    speed: 10000,
    autoplay: {
        delay: 0,
        disableOnInteraction: false,
    },
});

const featuresSliderRight = new Swiper('.features-slider-right', {
    modules: [Navigation, Pagination, Scrollbar, Autoplay, EffectFade, Thumbs, FreeMode, Mousewheel],
    direction: "vertical",
    slidesPerView: "auto",
    spaceBetween: 28,
    loop: true,
    speed: 10000,
    centeredSlides: true,
    autoplay: {
        delay: 0,
        reverseDirection: true,
        disableOnInteraction: false,
    },
});

export const servicesSlider = new Swiper('.services-slider', {
    modules: [Navigation, Pagination, Scrollbar, Autoplay, EffectFade, Thumbs, FreeMode, Mousewheel],
    slidesPerView: 1,
    spaceBetween: 28,
    enabled: window.innerWidth >= 1024, // Отключаем Swiper на мобильных устройствах
    pagination: {
        el: '.services-pagination',
        clickable: true,
    },
    on: {
        resize: function() {
            // Включаем/отключаем Swiper при изменении размера окна
            if (window.innerWidth >= 1024) {
                this.enable();
            } else {
                this.disable();
            }
        }
    }
});

const testimonialsSlider = new Swiper('.testimonials-slider', {
    modules: [Navigation, Pagination, Scrollbar, Autoplay, EffectFade, Thumbs, FreeMode, Mousewheel],
    slidesPerView: 1,
    spaceBetween: 54,
    pagination: {
        el: '.testimonials-pagination',
        clickable: true,
    },
    breakpoints: {
        768: {
            slidesPerView: 2,
        },
        1024: {
            slidesPerView: 2,
            spaceBetween: 118,
        },
    },
});

const tariffsSlider = new Swiper('.tariffs-slider', {
    modules: [Navigation, Pagination, Scrollbar, Autoplay, EffectFade, Thumbs, FreeMode, Mousewheel],
    slidesPerView: "auto",
    spaceBetween: 33,
    autoplay: {
        delay: 3000,
        disableOnInteraction: false,
    },
    freeMode: false,
    breakpoints: {
        678: {
            slidesPerView: "auto",
            autoplay: false,
        },
        1024: {
            slidesPerView: 3,
            freeMode: true,
            autoplay: false,
        },
    },
});

export const stepsSlider = new Swiper('.steps-slider', {
    modules: [Navigation, Pagination, Scrollbar, Autoplay, EffectFade, Thumbs, FreeMode, Mousewheel],
    slidesPerView: 1,
    spaceBetween: 28,
    pagination: {
        el: '.steps-pagination',
        clickable: true,
    },
});

const featuresSliderMobile = new Swiper('.features-slider-mobile', {
    modules: [Navigation, Pagination, Scrollbar, Autoplay, EffectFade, Thumbs, FreeMode, Mousewheel],
    slidesPerView: "auto",
    spaceBetween: 28,
    centeredSlides: true,
    loop: true,
    speed: 10000,
    autoplay: {
        delay: 0,
        disableOnInteraction: false,
    },
});

const twoBlocksItemsSlider = new Swiper('.two-blocks__items', {
    modules: [Navigation, Pagination, Scrollbar, Autoplay, EffectFade, Thumbs, FreeMode, Mousewheel],
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    navigation: {
        nextEl: '.two-blocks__items-arrow-next',
        prevEl: '.two-blocks__items-arrow-prev',
    },
});